export const REPORT_SECTION_OPTIONS = [
  { id: "budget", label: "Budget", daemonValue: "budget", icon: "budget" },
  { id: "arcPlc", label: "ARC/PLC", daemonValue: "arcplc", icon: "arcPlc" },
  { id: "insuranceSummary", label: "Insurance Summary", daemonValue: "insurance-summary", icon: "insurance" },
  { id: "overlapCharts", label: "Overlap Charts", daemonValue: "overlap-charts", icon: "reports" },
];

export const REPORT_SECTION_TASK_PROPERTY = "selected_sections";
